import './assets/css/App.css';

import {
  DEFAULT_MAIN_SUBTITLE,
  EXIT_PAGE_MESSAGE,
  SECOND_MAIN_TITLE,
  THANK_YOU_LENDER_LIST_ROUTE,
  THANK_YOU_THUMBTACK,
  THANK_YOU_MAO_ROUTE,
  THANK_YOU_ALTERNATIVE_ROUTE,
} from './lib/constants';
import {
  Disclaimer,
  MainForm,
  PageTitle,
  ThankYouLenderList,
  TopBarAndFooter,
  VWOComponent,
} from './components';

import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import {
  useAnura,
  useExitConfirmation,
  useExternalScript,
  useJornaya,
  useTrustedForm,
} from './lib/hooks';

import { CustomPixelHelmet } from './components/CustomComponents';
import ReactGA from 'react-ga4';
import { useEffect } from 'react';
import ThankYouThumbtack from './components/ThankYouAlternative/ThankYouThumbtack';
import ThankYouMAO from './components/ThankYouAlternative/ThankYouMAO';
import ThankYouAlternative from './components/ThankYouAlternative/ThankYouAlternative';

function App() {
  useExitConfirmation(EXIT_PAGE_MESSAGE);
  useJornaya();
  useTrustedForm();
  useAnura();
  useExternalScript(
    'https://rgr-js.s3.us-west-2.amazonaws.com/tracking.js',
    'tracking_env',
    process.env.REACT_APP_ENV
  );

  useEffect(() => {
    ReactGA.initialize(process.env.REACT_APP_GA_WINDOWS);
    ReactGA.send({
      hitType: 'pageview',
      page: '/',
    });
    ReactGA.event({
      category: 'GWT Landing',
      action: 'GWT Landing',
      label: 'GWT Landing',
    });
  }, []);

  return (
    <div className="page">
      <PageTitle title={process.env.REACT_APP_TAB_NAME} />
      <CustomPixelHelmet />
      <Router>
        <div className="main-content">
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <TopBarAndFooter showNumber={true} />
                  <MainForm />
                  <div>
                    <div className="disclaimer">
                      <Disclaimer />
                    </div>
                    <TopBarAndFooter className="top-bar-and-footer__bottom-gray " />
                  </div>
                </>
              }
            />

            <Route
              path="/v2"
              element={
                <>
                  <TopBarAndFooter showNumber={true} />
                  <VWOComponent />
                  <MainForm
                    title={SECOND_MAIN_TITLE}
                    subtitle={DEFAULT_MAIN_SUBTITLE.toLowerCase()}
                  />
                  <div>
                    <div className="disclaimer">
                      <Disclaimer />
                    </div>
                    <TopBarAndFooter className="top-bar-and-footer__bottom-gray " />
                  </div>
                </>
              }
            />
            <Route
              path={THANK_YOU_LENDER_LIST_ROUTE}
              element={
                <>
                  <TopBarAndFooter className="top-bar-and-footer__bottom-gray " />
                  <ThankYouLenderList />
                </>
              }
            />
            <Route
              path={THANK_YOU_THUMBTACK}
              element={
                <>
                  <TopBarAndFooter />
                  <ThankYouThumbtack />
                </>
              }
            />
            <Route
              path={THANK_YOU_MAO_ROUTE}
              element={
                <>
                  <TopBarAndFooter className="top-bar-and-footer__bottom-gray " />
                  <ThankYouMAO />
                </>
              }
            />
            <Route
              path={THANK_YOU_ALTERNATIVE_ROUTE}
              element={
                <>
                  <TopBarAndFooter className="top-bar-and-footer__bottom-gray " />
                  <ThankYouAlternative />
                </>
              }
            />
          </Routes>
        </div>
      </Router>
    </div>
  );
}

export default App;
